/* eslint-disable consistent-return */
/* eslint-disable no-await-in-loop */
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Market, { Categories as MarketCategories } from 'models/business/Market';
import Asset from 'models/business/Asset';
import HideableContainer from 'components/Common/HideableContainer';
// import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import ContentFeedField from 'components/pages/ResourceSetting/Widgets/ContentFeedField';
// import OrangeButton from 'components/Common/OrangeButton';
// import LightBlueButton from 'components/Common/LightBlueButton';
// import Checkbox from 'components/Common/Checkbox';
import ActionButton from 'components/Common/ActionButton';
import TitleBar from 'components/Common/TitleBar';
import HeaderTypography from 'components/Common/HeaderTypography';
import MarketSeletor from 'components/Common/MarketSeletor';
import TextInput from 'components/Common/TextInput';
import {
  shopeeUrl,
  shopeeName,
  shopeeId,
} from 'assets/exports/imageExport';
import pchomeContentFeed from 'assets/pchome.xlsx';
import API from 'api';
import Styles from './index.module.css';

const steps = [
  '我的廣告',
  '商城設定',
];

export default function MarketSetting() {
  const history = useHistory();
  const location = useLocation();
  const [market, setMarket] = useState(new Market());
  // const [isDefault, setIsDefault] = useState(false);
  const [contentFeedFile, setContentFeedFile] = useState();
  const [existingMallFeeds, setExistingMallFeeds] = useState([]);

  const handleChangeField = (e, field) => {
    const newMarket = market.clone();
    newMarket[field] = e.target.value;
    setMarket(newMarket);
  };

  const checkUrlValid = (e, field) => {
    const regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    if (!regex.test(market[field])) {
      alert('請提供正確的連結');
      setMarket(new Market());
    }
  };

  const fetchMarketFeeds = async (id) => {
    if (!id) return [];
    const result = await API.mall.getMallAssets(id);
    if (result.error) {
      alert(result.error.errorMsg);
      return [];
    }

    const marketFeeds = (result.resultData || []).map((a) => new Asset(a));
    return marketFeeds;
  };

  useEffect(() => {
    const newMarket = new Market(location.state);
    fetchMarketFeeds(newMarket.id).then((feeds) => {
      setExistingMallFeeds(feeds);
      setContentFeedFile(feeds[0]);
      setMarket(new Market(location.state));
    });
  }, [location.state]);

  const saveMarketOnClick = async () => {
    let result;

    if (!market.id) {
      if (market.category === MarketCategories.PChome) {
        if (!contentFeedFile) return alert('您尚未完成所有必填欄位，請先完成欄位後，再按下儲存賣場');
      }
      result = await API.mall.postNewMall(market.toNewJSON());
      if (!result.error) {
        const newMarket = new Market(result.resultData);
        const file = contentFeedFile || new File([''], 'inventory.csv');
        result = await API.mall.postMallMedia(newMarket.id, file);
      }
    } else {
      if (market.category === MarketCategories.PChome) {
        if (!contentFeedFile) return alert('您尚未完成所有必填欄位，請先完成欄位後，再按下儲存賣場');
      }
      result = await API.mall.postUpdateMall(market.toJSON());
      if (!result.error) {
        if (!contentFeedFile?.id) {
          for (let i = 0; i < existingMallFeeds.length; i += 1) {
            await API.mall.deleteMallAsset(existingMallFeeds[i].id);
          }

          if (contentFeedFile) {
            result = await API.mall.postMallMedia(market.id, contentFeedFile);
          }
        }
      }
    }

    if (result.error) {
      alert('您尚未完成所有必填欄位，請先完成欄位後，再按下儲存賣場');
    } else {
      history.push('/MyAds');
    }
  };

  return (
    <div className={Styles.marketingSettingsConatiner}>
      <div className={Styles.marketingSettingsFormWrapper}>
        <Box
          display="flex"
          flexDirection="column"
        >
          <Box
            mb={5}
          >
            <TitleBar steps={steps} />
          </Box>
          <div className={Styles.marketingSettingsForm}>
            {!market.id && (
              <Box
                display="flex"
                flexDirection="row"
                m={1}
              >
                <Box alignSelf="flex-start">
                  <HeaderTypography>賣場</HeaderTypography>
                  <MarketSeletor value={market.category} onChange={(value) => handleChangeField({ target: { value } }, 'category')} />
                </Box>
              </Box>
            )}
            <div className={Styles.marketingSettingsRow}>
              <Box className={Styles.leftColumn}>
                <HeaderTypography>
                  {market.category === MarketCategories.PChome ? '品牌產品頁集合連結' : '賣場連結'}
                  <span style={{ color: 'red' }}>*</span>
                </HeaderTypography>
                <TextInput
                  type="url"
                  value={market.url}
                  onChange={(e) => handleChangeField(e, 'url')}
                  onBlur={(e) => checkUrlValid(e, 'url')}
                />
              </Box>
              <Box className={Styles.rightColumn}>
                {market.category === MarketCategories.Shopee && <img src={shopeeUrl} alt="shopee" />}
              </Box>
            </div>
            <div className={Styles.marketingSettingsRow}>
              <Box className={Styles.leftColumn}>
                <HeaderTypography>
                  {market.category === MarketCategories.PChome ? '品牌名稱' : '賣場名稱'}
                  <span style={{ color: 'red' }}>*</span>
                </HeaderTypography>
                <TextInput value={market.name} onChange={(e) => handleChangeField(e, 'name')} />
              </Box>
              <Box className={Styles.rightColumn}>
                {market.category === MarketCategories.Shopee && <img src={shopeeName} alt="shopee" />}
              </Box>
            </div>
          </div>
          <div className={Styles.marketingSettingsForm}>
            <HideableContainer hidden={market.category === MarketCategories.PChome}>
              <div className={Styles.marketingSettingsRow}>
                <Box className={Styles.leftColumn}>
                  <HeaderTypography>
                    賣場編號
                    <span style={{ color: 'red' }}>*</span>
                  </HeaderTypography>
                  <TextInput
                    value={market.serial}
                    onChange={(e) => {
                      handleChangeField({ target: { value: e.target.value.replace(/[^0-9]/g, '') } }, 'serial');
                    }}
                    preventNumberFormat
                  />
                </Box>
                <Box className={Styles.rightColumn}>
                  {market.category === MarketCategories.Shopee && <img src={shopeeId} alt="shopee" />}
                </Box>
              </div>
            </HideableContainer>
            <Box
              m={1}
              display="flex"
              flexDirection="row"
              alignContent="left"
            >
              <Box className={Styles.leftColumn}>
                <HeaderTypography>
                  Facebook粉絲團連結
                </HeaderTypography>
                <TextInput type="url" value={market.fanPageUrl} onBlur={(e) => checkUrlValid(e, 'url')} onChange={(e) => handleChangeField(e, 'fanPageUrl')} />
              </Box>
              <Box className={Styles.rightColumn}>
                {market.category === MarketCategories.Shopee && null}
              </Box>
            </Box>
          </div>
          <HideableContainer hidden={market.category !== MarketCategories.PChome}>
            <Box
              display="flex"
              p={3}
              mt={1}
              flexDirection="column"
              alignContent="left"
              bgcolor="white"
              borderRadius="borderRadius"
              // height="5vh"
              width="100%"
              boxShadow={3}
            >
              <ContentFeedField
                link={pchomeContentFeed}
                value={contentFeedFile?.name}
                onChange={setContentFeedFile}
              />
            </Box>
          </HideableContainer>
          {/* <div style={{ paddingTop: 20, display: 'flex' }}>
            <Checkbox value={isDefault} onChange={setIsDefault} style={{ height: 20, width: 20 }} />
            <span style={{ color: '#455780', paddingLeft: 10 }}>設為預設賣場</span>
          </div> */}
          <div style={{ paddingTop: 20, paddingBottom: 20 }}>
            <ActionButton style={{ color: '#FFFFFF' }} onClick={saveMarketOnClick}>
              儲存賣場
            </ActionButton>
          </div>
        </Box>
      </div>

    </div>
  );
}
